import React, { memo } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

export interface ITableProps {
  dataSource: object[];
  columns: GridColDef[];
  localeText?: any;
  [props: string]: any;
}

const Table: React.FC<ITableProps> = ({
  columns,
  dataSource,
  localeText,
  ...rest
}): JSX.Element => {
  return (
    <>
      <DataGrid columns={columns} rows={dataSource} {...rest} localeText={localeText} />
    </>
  );
};

export default memo(Table);
